export default {

	html: `
		<style>
			#manual-action-form #ma_company_id { width: 24rem; }
			#manual-action-form #ma_integration_key { width: 12rem; }
			#manual-action-form #ma_action_key { width: 18rem; }
			#manual-action-form #ma_date_from,
			#manual-action-form #ma_date_to { width: 10rem; }
			#manual-action-form #ma_notes { width: 100%; }
		</style>
		<form id="manual-action-form" class="form" autocomplete="off">
			<div class="title">Registrar ação manual de integração</div>
			<p class="mtm" style="max-width:44rem;font-size:0.9rem;color:var(--color-muted,#555);">
				Use este registro para contingência operacional (falhas/reprocessamento manual). A ação fica auditável na Central.
			</p>
			<div class="mtl fsb">
				<label title="Empresa">Empresa
					<input id="ma_company_id" type="text" list="manual_action_companies" required placeholder="UUID da empresa">
				</label>
				<label title="Integração">Integração
					<select id="ma_integration_key" required>
						<option value="">Selecione</option>
						<option value="vendatus">Vendatus</option>
						<option value="iqvia">IQVIA</option>
						<option value="closeup">Close-up</option>
					</select>
				</label>
				<label title="Tipo da ação manual">Ação
					<input id="ma_action_key" type="text" required placeholder="ex.: reprocessar_lote">
				</label>
			</div>
			<div class="mtm fsb">
				<label title="Data inicial (opcional)">De
					<input id="ma_date_from" type="date">
				</label>
				<label title="Data final (opcional)">Até
					<input id="ma_date_to" type="date">
				</label>
			</div>
			<div class="mtm">
				<label title="Observações da ação">Observações
					<textarea id="ma_notes" rows="5" placeholder="Descreva o motivo e o que deve ser executado manualmente"></textarea>
				</label>
			</div>
			<datalist id="manual_action_companies"></datalist>
			<div class="mtm">
				<button class='bn_Escape button' type="button">Cancelar</button>
				<button class='bn_Enter button' type="submit">Registrar ação</button>
			</div>
		</form>
	`,

	form:
	{
		selector: '#manual-action-form',
		init(formset)
		{
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#ma_company_id' }, types: [], placeholder: '', title: 'Empresa' },
		{ properties: { selector: '#ma_integration_key' }, types: [], placeholder: '', title: 'Integração' },
		{ properties: { selector: '#ma_action_key' }, types: [], placeholder: 'reprocessar_lote', title: 'Ação' },
		{ properties: { selector: '#ma_date_from' }, types: [], placeholder: '', title: 'Data inicial' },
		{ properties: { selector: '#ma_date_to' }, types: [], placeholder: '', title: 'Data final' },
		{ properties: { selector: '#ma_notes' }, types: [], placeholder: '', title: 'Observações' },
	],
};
